<template>
<modal name="newgrade-dialog"
  :adaptive="true"
  :scrollable="true"
  height="auto">
  <div class="v--modal-close-top" v-loading.fullscreen.lock="fullscreenLoading">
    <el-button @click="closeDialog"
      icon="el-icon-close"
      type="text"></el-button>
  </div>
  <div style="display: inline-block;min-width: 100%;text-align:center;" v-if="permissionType == 1">
    <div style="display: inline-block;min-width: 100%;text-align:center;">
      <p style="font-size: 140%;">ダウンロードが完了しました！</p>
      <p style="font-size: 140%;">就職活動もいよいよ終盤戦！</p>
      <p style="font-size: 140%;">最短２週間で内定が貰える採用枠があるよ！</p>
      <p style="font-size: 140%;">サポートするから無料相談してみて！</p>
      <div style="display: inline-block;min-width: 100%;text-align:center;">
        <p style="font-size: 140%;"> 
          <img src="/static/renew_img/saiplus_yagish_logo.png" style="width:80%" >
        </p>
      </div>
    </div>
    <br/>
    <br/>
    <div style="display: inline-block;min-width: 100%;text-align:center;">
      <p>
        Yagishの<router-link id="footer-link-terms" :to="{name: 'termsPage'}" target="_blank">利用規約</router-link>、<router-link id="footer-link-policy" :to="{name: 'policyPage'}" target="_blank">個人情報保護方針</router-link>
        <br/>
        ㈱アド・トップの<a href="https://adtop-web.com/saiplus/agent/careerup/tos.html" target="_blank">利用規約</a>、<a href="https://adtop-web.com/privacypolicy.html" target="_blank">個人情報保護方針</a>
      </p>
      <!-- <p>
        ㈱アイデムの<a href="https://jobrass.com/gakusei/SCST00503" target="_blank">利用規約</a>、<a href="https://www.aidem.co.jp/policy/index.html" target="_blank">個人情報保護方針</a>、<a href="https://jobrass.com/agent/" target="_blank">詳細ページ</a>
      </p> -->
    </div>
    <br/>
    <br/>
    <div class="text-center">
      <el-button id="send-adtop-pdf" type="success" v-if="isSended == false" style="background-color:#F60B26;border-color:#F60B26;font-size: 140%;"
        @click="$eventHub.$emit('send-newgrade-consult', 23);">規約に同意して無料相談する</el-button>
      <el-button id="send-adtop-pdf" type="success" v-if="isSended == true"
        @click="closeDialog();">送信しました</el-button>
    </div>
    <br/>
    <div class="text-center" v-if="false">
      <el-button id="send-adtop-pdf" v-if="isSended == false" type="primary" style="background-color:#999;border-color:#999;" @click="closeDialog();">サポートは受けない</el-button>
      <el-button id="send-adtop-pdf" v-if="isSended == true" type="primary" style="background-color:#999;border-color:#999;" @click="closeDialog();">閉じる</el-button>
    </div>
    <br/>
  </div>
  <div style="display: inline-block;min-width: 100%;text-align:center;" v-else-if="permissionType == 2">
    <div style="display: inline-block;min-width: 100%;text-align:center;">
      <p style="font-size: 140%;">ダウンロードが完了しました！</p>
      <p style="font-size: 140%;">リクナビ、マイナビでは見つけずらい優良企業をご紹介！</p>
      <p style="font-size: 140%;">もちろん、非公開求人もあるよ♪</p>
      <p style="font-size: 140%;">サポートするから無料相談してみてね。</p>
      <div style="display: inline-block;min-width: 100%;text-align:center;">
        <p style="font-size: 140%;"> 
          <img src="/static/renew_img/saiplus_yagish_logo.png" style="width:80%" >
        </p>
      </div>
    </div>
    <br/>
    <br/>
    <div style="display: inline-block;min-width: 100%;text-align:center;">
      <p>
        Yagishの<router-link id="footer-link-terms" :to="{name: 'termsPage'}" target="_blank">利用規約</router-link>、<router-link id="footer-link-policy" :to="{name: 'policyPage'}" target="_blank">個人情報保護方針</router-link>
        <br/>
        ㈱アド・トップの<a href="https://adtop-web.com/saiplus/agent/careerup/tos.html" target="_blank">利用規約</a>、<a href="https://adtop-web.com/privacypolicy.html" target="_blank">個人情報保護方針</a>
      </p>
      <!-- <p>
        ㈱アイデムの<a href="https://jobrass.com/gakusei/SCST00503" target="_blank">利用規約</a>、<a href="https://www.aidem.co.jp/policy/index.html" target="_blank">個人情報保護方針</a>、<a href="https://jobrass.com/agent/" target="_blank">詳細ページ</a>
      </p> -->
    </div>
    <br/>
    <br/>
    <div class="text-center">
      <el-button id="send-adtop-pdf" type="success" v-if="isSended == false" style="background-color:#F60B26;border-color:#F60B26;font-size: 140%;"
        @click="$eventHub.$emit('send-newgrade-consult', 24);">規約に同意して無料相談する</el-button>
      <el-button id="send-adtop-pdf" type="success" v-if="isSended == true"
        @click="closeDialog();">送信しました</el-button>
    </div>
    <br/>
    <div class="text-center" v-if="false">
      <el-button id="send-adtop-pdf" v-if="isSended == false" type="primary" style="background-color:#999;border-color:#999;" @click="closeDialog();">サポートは受けない</el-button>
      <el-button id="send-adtop-pdf" v-if="isSended == true" type="primary" style="background-color:#999;border-color:#999;" @click="closeDialog();">閉じる</el-button>
    </div>
    <br/>
  </div>


</modal>
</template>
<style lang="scss" src="@/assets/scss/pages/pages.scss"></style>
<style lang="scss" src="@/assets/scss/pages/setting.scss"></style>
<script>
export default {
  components: {
  },
  data: function () {
    return {
      clearLocalStorageConfirmVisible: false,
      currentFormat: {},
      formatid: '',
      previewHtml: '',
      gradeYear: 0,
      permissionType: 1,
      isSended:false,
      fullscreenLoading:false,
      username:'',
      baite_title:'バイト',
      isAgree:false,
      inputEmail:'',
      foreignStudent:false,
      isRandom:true
    }
  },
  created : function(){
    console.error('newgrade created')
    const app = this
    this.$iterateStorage(function (value, key, iterationNumber) {
        //console.log all the kay/value pairs
        if (key === 'basicData') {
          app.username = value.lastName + '_' + value.firstName
        }
        if (key === 'format_rirekisho') {
          app.gradeYear = value.gradeYear
        }
    }, function (err) {
        if (!err) {
            console.log('Iteration has completed');
        }
    })
  },
  computed: {
    cleanedPreviewHtml: function () {
      // PDFで文字化けするやつを変換しておく
      return this.previewHtml
    },
    pdfFormData: function () {
      const formData = new FormData()
      formData.append('app_html', this.cleanedPreviewHtml)
      formData.append('pdf_option', 'A4')
      return formData
    }
  },
  methods: {
    opennewgradeDialog: function (id, html, email, grade) {
      this.formatid = id
      this.previewHtml = html.$el.innerHTML
      this.inputEmail = email
      this.gradeYear = grade
      this.$modal.show('newgrade-dialog')
      this.clearLocalStorageConfirmVisible = false
      const app = this
      this.$iterateStorage(function (value, key, iterationNumber) {
          if (key === 'basicData') {
            app.username = value.lastName + '_' + value.firstName
          }
          if (key === 'format_rirekisho') {
            app.foreignStudent = value.foreignStudent
            console.error(app.foreignStudent)
          }
          if (app.foreignStudent) {
            app.permissionType = 4
          } else {
            if (app.gradeYear == 23) {
              app.permissionType = 1
            } else if (app.gradeYear == 24) {
              app.permissionType = 2
            } else {
              app.permissionType = 2
            }
            if (Math.floor(Math.random() * 2) == 0) {
              app.isRandom = false
            } else {
              app.isRandom = true
            }
          }
      }, function (err) {
          if (!err) {
              console.log('Iteration has completed');
          }
      })

      const formData = new FormData()
      formData.append('uuid', this.$firebase.user.uid)
      formData.append('format_id', this.formatid)
      formData.append('dialog_name', 'newgrade_dialog')
      formData.append('permission_type', this.permissionType)
      formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP': 'PC')
      formData.append('version', '2')
      formData.append('site_flag', 'd')
      formData.append('app_flag', '')
      this.$axios.post(this.$varuna.endPoints.displayDialog, formData, {timeout: 60000})
    },
    closeDialog: function () {
      this.$modal.hide('newgrade-dialog')
      this.clearLocalStorageConfirmVisible = false
    },
    clearLocalStorage: function () {
      this.$clearStorage()
      window.location = '/'
    },
    createFilename: function (ext) {
      const now = new Date()
      const prefix = process.env.VUE_APP_DOWNLOAD_FILENAME_PREFIX
      const dateString = this.$formLib.dateFormat(now, '_yyyy-mm-dd_HH-MM-ss')
      return `${prefix}${this.formatid}${dateString}.${ext}`
    },
    sendnewgradeConsult: async function (grade) {
      if (!this.$deviceLib.isOnline) {
        this.$message({
          message: '現在オフラインです。インターネットにつながってから再度お試しください',
          type: 'warning'
        })
        return
      }
      await this.$firebase.reloadToken()
      const accessToken = this.$firebase.accessToken
      if (!accessToken || !this.$firebase.user.email) {
        this.$message({
          message: 'ログインが必要です',
          type: 'warning'
        })
        return
      }
      const app = this
      this.fullscreenLoading = true
      const formData = this.pdfFormData
      formData.append('token', accessToken)
      formData.append('apikey', this.$firebase.config.apiKey)
      formData.append('uuid', this.$firebase.user.uid)
      formData.append('format_id', this.formatid)
      if ((!this.$firebase.user.email && this.inputEmail) || 
        (this.$firebase.user.email.indexOf('@privaterelay.appleid.com') > 0 && this.inputEmail)) {
        formData.append('inputemail', this.inputEmail)
      }
      formData.append('yaginame', this.username)
      formData.append('app_flag', '')
      formData.append('filename', this.createFilename('pdf'))
      if (grade == 23) {
        formData.append('contents_id', process.env.VUE_APP_ADTOP_NEWGRADE23_CONTENTS_ID)
      } else {
        formData.append('contents_id', process.env.VUE_APP_ADTOP_NEWGRADE24_CONTENTS_ID)
      }
      formData.append('dialog_name', 'newgrade_dialog')
      formData.append('permission_type', this.permissionType)
      formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP': 'PC')
      formData.append('version', '2')
      formData.append('reqflg', '2')
      this.$axios
        .post(this.$varuna.endPoints.sendAdtopApi, formData, {timeout: 60000})
        .then(function (response) {
          app.isSended = true
          app.$message({
            duration: 0,
            showClose: true,
            dangerouslyUseHTMLString: true,
            message: `担当者からあなたのメールアドレスに連絡が届くことがあります！`,
            type: 'info'
          })
        })
        .catch(function (error) {
          app.$message({
            message: '送信失敗しました',
            type: 'error'
          })
          app.$gtm.sendError('pdf mail', `send pdf mail failed ${error}`)
        }).finally(function () {
          app.fullscreenLoading = false
        })
    },
    sendYagishRecruit: async function () {
      if (!this.$deviceLib.isOnline) {
        this.$message({
          message: '現在オフラインです。インターネットにつながってから再度お試しください',
          type: 'warning'
        })
        return
      }
      await this.$firebase.reloadToken()
      const accessToken = this.$firebase.accessToken
      if (!accessToken || !this.$firebase.user.email) {
        this.$message({
          message: 'ログインが必要です',
          type: 'warning'
        })
        return
      }
      const app = this
      this.fullscreenLoading = true
      const formData = this.pdfFormData
      formData.append('token', accessToken)
      formData.append('apikey', this.$firebase.config.apiKey)
      formData.append('uuid', this.$firebase.user.uid)
      formData.append('format_id', this.formatid)
      if ((!this.$firebase.user.email && this.inputEmail) || 
        (this.$firebase.user.email.indexOf('@privaterelay.appleid.com') > 0 && this.inputEmail)) {
        formData.append('inputemail', this.inputEmail)
      }
      formData.append('yaginame', this.username)
      formData.append('app_flag', '')
      formData.append('filename', this.createFilename('pdf'))
      formData.append('dialog_name', 'newgrade_dialog')
      formData.append('permission_type', this.permissionType)
      formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP': 'PC')
      formData.append('version', '2')
      formData.append('reqflg', '2')
      this.$axios
        .post(this.$varuna.endPoints.yagishRecruitPdfMail, formData, {timeout: 60000})
        .then(function (response) {
          // app.isSended = true
          app.$message({
            duration: 0,
            showClose: true,
            dangerouslyUseHTMLString: true,
            message: `担当者からあなたのメールアドレスに連絡が届くことがあります！`,
            type: 'info'
          })
        })
        .catch(function (error) {
          app.$message({
            message: '送信失敗しました',
            type: 'error'
          })
          app.$gtm.sendError('pdf mail', `send pdf mail failed ${error}`)
        }).finally(function () {
          app.fullscreenLoading = false
        })
    }
  },
  beforeMount: function () {
    this.$eventHub.$on('send-yagish-recruit', this.sendYagishRecruit)
    this.$eventHub.$on('send-newgrade-consult', this.sendnewgradeConsult)
    this.$eventHub.$on('open-newgrade-dialog', this.opennewgradeDialog)
    this.$eventHub.$on('popstate', this.closeDialog)
  },
  destroyed: function () {
    this.$eventHub.$off('send-yagish-recruit', this.sendYagishRecruit)
    this.$eventHub.$off('send-newgrade-consult', this.sendnewgradeConsult)
    this.$eventHub.$off('open-newgrade-dialog', this.opennewgradeDialog)
    this.$eventHub.$off('popstate', this.closeDialog)
  }
}
</script>
